import React, { useState } from "react";
import { FaRegSave } from "react-icons/fa";
import { Link } from "react-router-dom";
import Header from "../../../header/header";
import Navvbar from "../../../header/Navvbar";
import Footer from "../../../footer.js";

const AssignAccountTags = () => {
  const accounts = [
    { name: "37 Dental and Implant Centre" },
    { name: "Abacus Dental and Implant Clinic" },
    { name: "abc" },
    { name: "Adrian Popovici" },
    { name: "Affinity Dental Clinic Basildon" },
    { name: "Alaska House Dental Practice" },
    { name: "ALL SAINTS DENTAL" },
    { name: "Ammer Ali" },
    { name: "Andrew Lee (Diu Resh)" },
    { name: "Andrew Lee Dental (Bardha Jas)" },
    { name: "Andrew Lee Dental (Roebuck Louise)" },
    { name: "Andrew Lee Dental (T Hyare)" },
  ];

  const [selectedAccounts, setSelectedAccounts] = useState([]);

  const handleToggle = (accountName) => {
    if (selectedAccounts.includes(accountName)) {
      setSelectedAccounts(selectedAccounts.filter((name) => name !== accountName));
    } else {
      setSelectedAccounts([...selectedAccounts, accountName]);
    }
  };

  const handleSave = () => {
    
    // Add your save logic here, e.g., API call
  };

  return (
    <>
      <div style={{ marginBottom: "25px" }}>
        <Header />
        <Navvbar />
      </div>
      <div style={{ width: "95%", margin: "0 auto", padding: "0px" }}>
        <div className="row">
          {/* Sidebar from CaseSetting */}
          <div
            className="col-md-2"
            style={{ borderRight: "1px solid #004aad" }}
          >
            <div>
              <h2 style={{ marginLeft: "10px" }}>Settings</h2>
              <div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/Tabs"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Lab Details
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "13px",
                    }}
                  >
                    Store
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/usersetting"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Users
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Permission Groups
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/Account"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Accounts
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/Owerviews"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Finances
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/owersetting"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Case Settings
                  </Link>
                </div>
              </div>
            </div>
          </div>
          {/* Main Content */}
          <div className="col-md-10">
            <h1>Assign Account Tags</h1>
            <h2 style={{ color: "#004aad", marginBottom: "10px" }}>Account Tags</h2>
            <div style={{ backgroundColor: "#f4f4f4", padding: "10px", display: "flex", alignItems: "center", borderTop: "2px solid #004aad" }}>
              <label style={{ marginRight: "10px", fontWeight: "bold", width: "100px" }}>Tag</label>
              <select style={{ width: "190px", padding: "8px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: "white" }}>
                <option>Select Tag</option>
                <option>New Tag</option>
                <option>a-practices</option>
              </select>
            </div>
            <h2 style={{ color: "#004aad", marginTop: "15px", marginBottom: "10px" }}>Accounts</h2>
            <div style={{ backgroundColor: "#f0f0f0", padding: "10px", display: "flex", flexDirection: "column", borderTop: "2px solid #004aad" }}>
              {accounts.map((account, index) => (
                <div key={index} style={{ display: "flex", alignItems: "center", marginBottom: "5px" }}>
                  <label>{account.name}</label>
                  <input
                    type="checkbox"
                    style={{ marginLeft: "10px" }}
                    checked={selectedAccounts.includes(account.name)}
                    onChange={() => handleToggle(account.name)}
                  />
                </div>
              ))}
            </div>
            {/* Save Bar */}
            <div style={{ padding: "10px", display: "flex", alignItems: "center", marginTop: "20px" }}>
              <button
                onClick={handleSave}
                style={{
                  backgroundColor: "#004aad",
                  color: "white",
                  padding: "8px 12px",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  marginRight: "10px",
                }}
              >
                <FaRegSave /> Save
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Footer */}
      <div style={{ width: "95%", margin: "0 auto", padding: "0px" }}>
        <Footer />
      </div>
    </>
  );
};

export default AssignAccountTags;